import moment from "moment";
import { Button, Card, Col, Form, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useLocalStorage } from "react-use";
import { ISubscription } from "../../../../../../models/ISubscriptionDetails";
import formatCurrency from "../../../../../../utils/formatCurrency";
import { useRecoilState } from "recoil";
import { subscriptionState } from "../../../../../../../hooks/atoms/subscriptions";

export const CardSignatureDetail = (): JSX.Element => {
    const { t: translation } = useTranslation();
    const history = useHistory();
    // const [subscription,] = useLocalStorage<ISubscription>('subscription')
    const [subscription, setSubscriptionDetails] = useRecoilState(subscriptionState)
    

    return (
        <Card className="account-card mb-4">
            <Form>
                <Card.Body>
                    <Card.Title className="ml-5 mr-5 mb-0">
                        <Row>
                            <Col xs={12} className="d-flex align-items-center">
                                <h4 className="mb-0" style={{ fontSize: '18px', color: "#333333", fontWeight: 600 }}>{translation('userAccount.signature.label')}</h4>
                            </Col>
                        </Row>
                    </Card.Title>
                    <hr />
                    <Row className="py-3">
                        <Col md={12} className="d-flex align-items-center ml-5 mr-5">
                            <Row className="col-11">
                                <Col xs={12} className="mb-2">
                                    <Row>
                                        {!!subscription && (
                                            <Col sm={6} className="mt-2">
                                                <p><span className="text-darker-grey">Seu plano termina em {moment(subscription.subscription.subscription_end_date).format('LL')}</span> </p>
                                                <p><span className="text-darker-grey">Plano Atual: </span> {subscription.subscription.subscription_name}</p>
                                                <p><span className="text-darker-grey">Quantidade de materiais: </span> Até {subscription.subscription.subscription_limit} disciplinas </p>
                                                <p><span className="text-darker-grey">Valor: </span> {formatCurrency(subscription.subscription.subscription_installment)}/mês </p>
                                            </Col>
                                        )}
                                        <Col sm={6}>
                                            <Row>
                                                <Col sm={12} className="d-flex justify-content-end">
                                                    <Button id="renewSignature" variant="link" style={{ textDecoration: 'none' }} onClick={() => history.push('/contact?subject=Renovação')}>{translation('userAccount.signature.renew')}</Button>
                                                </Col>
                                                <Col sm={12} className="d-flex justify-content-end">
                                                    <Button variant="link" style={{ textDecoration: 'none' }} onClick={() => history.push('/contact?subject=Cancelar')}>{translation('userAccount.signature.cancel')}</Button>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Card.Body>
            </Form>
        </Card>
    )
}